import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import _ = require('lodash');
import { Subject } from 'rxjs';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';
import { CompanyMasterService } from 'src/app/services/companymaster.service';
import { UserMasterService } from 'src/app/services/user-master.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-risk-individual-report',
  templateUrl: './risk-individual-report.component.html',
  styleUrls: ['./risk-individual-report.component.css']
})
export class RiskIndividualReportComponent implements OnInit {
  @Input('companyLogo') companyLogo: any;
  assigneeDetails: any;
  assigneeDetailsAnswerDetails: any;
  calculatedCriteriaScoreArray: any;
  scoreRange: any;
  scoreParticulars: any;
  formTitle: any;
  averageScore: any;
  averageWeightedScore: any;
  averageScores: any;
  evaluationName: any;
  reportFormat: any;
  evaluationType: any;
  totalAverageWeightedScore: any;
  averageCriteriaQuestionAnswer: any = [];
  userInfo: any;
  showSpinner: boolean = false;
  companyName: string = '';
  subsidiaryCompanyName: string = '';
  loggedinUserId: string = '';
  loggedinUserProfilePic: string = '';
  base64Code: any = '';
  assigneeDetailsLength: number;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();
  evalueeId: any;
  evaluationFormId: any;
  evaluationTypeId: any;
  periodParameter: any;
  reportPeriodParameter: any = '';

  weigthedBarGraphOptions: Object;
  assesseeReportFor: any = '';

  todayDate: Date = new Date();

  scorPerCritariaQue: any[];
  isDownload: any = false;

  constructor(
    private riskEvaluationService: RiskEvaluationService,
    private route: ActivatedRoute,
    private userMasterService: UserMasterService,
    private companyMasterService: CompanyMasterService
  ) { }

  ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem('user'));

    this.route.params.subscribe((params) => {
      //console.log("params", params);
      this.evalueeId = params.evalueeId;
      this.evaluationFormId = params.evaluationFormId;
      this.evaluationTypeId = params.evaluationTypeId;
      this.periodParameter = params.periodParameter;
    });

    var evalObject = {
      // "EvaluaeeId": this.evalueeId,
      AssesseeId: this.evalueeId,
      EvaluationFormId: this.evaluationFormId,
      EvaluationTypeID: this.evaluationTypeId,
      PeriodParameter: this.periodParameter,
    };

    this.todayDate = new Date();
    var self = this;
    $('body').removeClass('dashboard-page');
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    this.riskEvaluationService.getIndividualReport(evalObject).then(response => {
      if (!response || response.status !== 0) return;

      const details = response.evaluationFormDetails || {};
      const evalTypeID = details.EvaluationTypeID;
      this.evaluationType = !evalTypeID || evalTypeID.EvaluationType;

      // Handle reportsTo block safely
      const reportsTo = details.reportsTo || [];
      if (Array.isArray(reportsTo) && reportsTo.length > 0) {
        const reportToDetails = _.filter(reportsTo, element => element.ReportsToId === this.userInfo._id);
        if (reportToDetails.length > 0) {
          this.reportFormat = reportToDetails[0].ReportType;
        }
      }

      // Safely map answerArray scores
      const answerArray = details.answerArray || [];
      if (Array.isArray(answerArray) && answerArray.length > 0 && answerArray[0]?.AnswerDetails) {
        if (
          Array.isArray(answerArray) &&
          answerArray.length > 0 &&
          Array.isArray(answerArray[0].AnswerDetails)
        ) {
          answerArray[0].AnswerDetails.forEach((ele, index) => {
            answerArray.forEach((element, idx) => {
              if (element.AnswerDetails && element.AnswerDetails[index]) {
                ele['director-' + idx] = element.AnswerDetails[index].AnswerScore;
              }
            });
          });
        }

      }

      // Assign details to component properties
      this.assigneeDetails = answerArray;
      this.assigneeDetailsAnswerDetails = answerArray[0]?.AnswerDetails || [];
      this.assigneeDetailsLength = answerArray.length;
      this.calculatedCriteriaScoreArray = answerArray[0]?.calculatedCriteriaScore || [];
      this.averageScores = details.averageWeightedScore;
      this.assesseeReportFor = details.assesseeReportFor;
      this.totalAverageWeightedScore = details.totalAverageWeightedScore;
      this.reportPeriodParameter = details.periodParameter;
      this.averageCriteriaQuestionAnswer = details.averageQuestionAnswerArrayAcrossDirectors;

      // Nested evaluationFormDetails object
      const formDetails = details.evaluationFormDetails || {};
      this.scoreRange = formDetails.ScoreRange;
      this.scoreParticulars = formDetails.ScoreParticulars;
      this.formTitle = formDetails.EvaluationFormTitle;
      this.averageScore = formDetails.averageScore;
      this.averageWeightedScore = formDetails.averageWeightedScore;
      this.evaluationName = formDetails.EvaluationFormTitle;

      // Fill average scores into criteria array
      if (
        this.calculatedCriteriaScoreArray.length &&
        Array.isArray(details.averageScore) &&
        Array.isArray(details.averageWeightedScore)
      ) {
        for (let i = 0; i < this.calculatedCriteriaScoreArray.length; i++) {
          this.calculatedCriteriaScoreArray[i].averageScore = details.averageScore[i];
          this.calculatedCriteriaScoreArray[i].averageWeightedScore = details.averageWeightedScore[i];
        }
      }

      // Final visual/data steps
      this.drawWeigthedBarGraph(this.averageWeightedScore);
      this.addCompanyLogo();
      this.dtTrigger.next();

      if (this.isDownload) {
        setTimeout(() => {
          this.download();
        }, 800);
      } else {
        this.showSpinner = false;
      }
    });

    this.companyName = JSON.parse(localStorage.getItem('user')).CompanyName;
    console.log('companyName', this.companyName);
    this.subsidiaryCompanyName = localStorage.getItem('subsidiaryCompanyName');

    this.loggedinUserId = JSON.parse(localStorage.getItem('user'))._id;

    this.userMasterService
      .getUserByUserId(this.loggedinUserId)
      .then((response) => {
        if (response.status == 0) {
          if (
            response.userDetails.ProfilePicture != undefined &&
            response.userDetails.ProfilePicture != null
          ) {
            $('#userProfilePic').attr(
              'src',
              response.userDetails.ProfilePicture
            );
          } else {
            $('#userProfilePic').attr('src', 'assets/images/DefaultImage.png');
            // $("#userProfilePic").attr("src", "assets/images/profile.svg");
            // this.loggedinUserProfilePic = "";
          }
        }
      });
  }

  ngAfterViewInit() {
    this.companyName = JSON.parse(localStorage.getItem('user')).CompanyName;

    this.companyMasterService.getCompanyList().then((company) => {
      console.log('company', company);
      if (company.status == 0) {
        if (
          company.companyData.CompanyLogo != null &&
          company.companyData.CompanyLogo != ''
        ) {
          this.base64Code =
            environment.serverIP + company.companyData.CompanyLogo;
          console.log('this.base64Code', this.base64Code);
          $('#clientCompanyLogo').attr('src', this.base64Code);
          this.companyLogo =
            environment.serverIP + company.companyData.CompanyLogo;
        } else {
          this.base64Code = '../../assets/images/company-icon.svg';
          // this.base64Code = this.companyLogo;
          //console.log("this.base64Code",this.base64Code);
          // $("#clientCompanyLogo").attr("src", this.base64Code);
        }
      }
      console.log('%%%%%%%%%%%', this.companyLogo);
    });
  }

  addCompanyLogo() { }

  drawWeigthedBarGraph(averageScoreArray) {
    var newBarData = [];

    //console.log(" [newBarData]", [newBarData]);
    //.-------------------------------------------------
    this.weigthedBarGraphOptions = {
      chart: {
        type: 'column',
        renderTo: 'weightedBarChart',
        fill: '#111',
      },
      title: {
        // text: 'Evaluation Summary for ' + this.evaluationName
        text: '',
      },

      xAxis: {
        type: 'category',
        title: {
          text: 'Weighted Average Score',
        },
        labels: {
          style: {
            fontSize: '10px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Scores',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        pointFormat: '{point.y:.2f}',
      },
      series: [
        {
          name: 'Entity',
          data: Array.isArray(averageScoreArray)
            ? averageScoreArray.map(point => [point.EvaluationCriteria, point.averageWeightedScore])
            : [],
          dataLabels: {
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y:.2f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
              fontSize: '10px',
              fontFamily: 'Verdana, sans-serif',
            },
          },
        },
      ],
    };
  }

  checkReportFormat(event) {
    if (this.reportFormat == 'summaryReport') {
    } else {
      //console.log("detailed Report")
    }
  }

  showAverageQuestionAnswer(questionId, scoreCount) {
    scoreCount = scoreCount + 1;
    if (_.size(this.averageCriteriaQuestionAnswer)) {
      var questionElementFound = _.filter(
        this.averageCriteriaQuestionAnswer,
        function (element) {
          return element.QuestionId == questionId;
        }
      );

      if (_.size(questionElementFound)) {
        if (
          questionElementFound[0].score >= scoreCount &&
          questionElementFound[0].score < scoreCount + 1
        ) {
          return questionElementFound[0].score;
        } else {
          return '';
        }
      } else {
        return ' ';
      }
    } else {
      return ' ';
    }
  }
  getIndex(assigneeDetails, limit, subLimit) {
    var arrayLength = assigneeDetails.length;
    var lastIndex = 1;
    if (arrayLength > 0) {
      assigneeDetails.forEach((element, index) => {
        if (index < limit && limit != 0) {
          lastIndex += assigneeDetails[index].calculatedCriteriaScore.length
        }
      });
    }
    return lastIndex + subLimit
  }

  // calculatedCriteriaScore

  convertImgToDataURLviaCanvas(url, callback, outputFormat) {
    if (this.base64Code == '../../assets/images/company-icon.svg') {
      console.log('+++++++++++++++');
      callback(undefined);
    } else {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = function () {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        callback(dataURL);
        canvas = null;
      };
    }
    // var img = new Image();
    // img.crossOrigin = 'Anonymous';
    // img.src = url;
    // img.onload = function () {
    //   var canvas = document.createElement('canvas');
    //   var ctx = canvas.getContext('2d');
    //   var dataURL;
    //   canvas.height = img.height;
    //   canvas.width = img.width;
    //   ctx.drawImage(img, 0, 0);
    //   dataURL = canvas.toDataURL(outputFormat);
    //   callback(dataURL);
    //   canvas = null;
    // };
  }

  download() {
    var base64img;
    console.log('this.base64Code', this.base64Code);
    this.convertImgToDataURLviaCanvas(
      this.base64Code,
      function (base64ImageData) {
        console.log('base64ImageData', base64ImageData);
        base64img = base64ImageData;
      },
      undefined
    );

    this.showSpinner = true;

    var self = this;
    const divId = document.getElementById('FirstPage'); //The html element to become a pdf

    const pdfHeader = document.getElementById('pdfHeader'); //The html element to become a pdf
    const pdf = new jsPDF('l', 'pt', 'a4');
    pdf.setFont('Times');
    pdf.setFontSize(30);

    const specialElementHandlers = {
      // element with id of "bypass" - jQuery style selector
      '#bypassme': function (element, renderer) {
        // true = "handled elsewhere, bypass text extraction"
        return true;
      },
    };

    const margins = {
      top: 80,
      bottom: 60,
      left: 40,
      width: 522,
    };

    var HTML_Width = $('#divId').width();
    var HTML_Height = $('#divId').height();
    var top_left_margin = 15;
    var PDF_Width = HTML_Width + top_left_margin * 2;
    var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;

    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    html2canvas(document.querySelector('#divId'), {
      scale: 1.1,
      allowTaint: false,
      backgroundColor: 'gray',
    }).then((canvas) => {
      canvas.getContext('3d');

      //console.log("sure" ,canvas.height+"  "+canvas.width);

      // let pdf = new jsPDF('p', 'mm', 'b3');
      // pdf.addImage(canvas.toDataURL('image/JPEG'), 'JPEG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height,'','FAST');

      var imgData = canvas.toDataURL('image/jpeg', 1.0);

      var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height], true);

      pdf.setFont('Times', 'Bold');
      pdf.setFontSize(25);
      //console.log("doc.getFontList()",pdf.getFontList())
      canvas.style.font = '40px Arial';
      var img1 = new Image();
      pdf.addImage(
        imgData,
        'JPG',
        top_left_margin,
        top_left_margin,
        canvas_image_width,
        canvas_image_height
      );
      console.log('base64img', base64img);
      if (base64img == undefined) {
      } else {
        pdf.addImage(base64img, 'JPG', 1330, 25, img1.width, 50);
      }

      // pdf.addImage(imagedata, 'JPEG', 1350, 15, 60, 60);
      // (left,top)

      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage([PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          'JPG',
          top_left_margin,
          -(PDF_Height * i) + top_left_margin * 4,
          canvas_image_width,
          canvas_image_height
        );
      }
      //pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 100, 200);
      this.showSpinner = false;
      setTimeout(function () {
        this.showSpinner = false;
        pdf.save(self.evaluationName + '.pdf');
      }, 2000);
    });
  }
}

